import * as React from 'react';
import { Formik, Form } from 'formik';

import NotifyHOC from '../../../../../HOC/Notifications';
import TextField from '../../../../common/textField';

import * as projectService from '../../../../../services/project.service';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../../../../common/modal';
import { duplicateQuestionValidationSchema } from '../../../../common/validation/validationSchema';
import { Notes } from '../../../../common/notes';

interface IDuplicateQuestionProps {
    onClose: () => void;
    duplicatedQuestion: any;
    toastNotification: any;
    handleSubmit: (duplicatedQuestion, values, actions) => void;
}

interface IDuplicateQuestionState {
    isRequesting: boolean;
}

class DuplicateQuestionModal extends React.Component<
    IDuplicateQuestionProps,
    IDuplicateQuestionState
> {
    constructor(props) {
        super(props);
        this.state = {
            isRequesting: false
        };
    }

    render() {
        const { isRequesting } = this.state;
        const { duplicatedQuestion } = this.props;
        const { isGroup, label } = duplicatedQuestion;
        return (
            <Modal isOpen={true}>
                <ModalHeader onClose={this.props.onClose}>
                    <ModalTitle>Duplicate question</ModalTitle>
                </ModalHeader>
                <Formik
                    initialValues={{
                        questionTitle: `${
                            duplicatedQuestion.title || duplicatedQuestion.label
                        } copy`
                    }}
                    validationSchema={duplicateQuestionValidationSchema}
                    onSubmit={(values, actions) => {
                        this.props.handleSubmit(
                            duplicatedQuestion,
                            values,
                            actions
                        );
                    }}
                    render={({
                        values,
                        touched,
                        handleChange,
                        handleBlur,
                        errors,
                        dirty,
                        isSubmitting
                    }) => (
                        <Form>
                            <ModalBody>
                                <label>
                                    {isGroup
                                        ? 'Please add a prefix for new questions'
                                        : 'Please add a new question title'}
                                </label>
                                <TextField
                                    type="text"
                                    name="questionTitle"
                                    value={values.questionTitle}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder={
                                        isGroup
                                            ? 'Title prefix'
                                            : 'Question title'
                                    }
                                    label={
                                        isGroup
                                            ? 'Title prefix'
                                            : 'Question title'
                                    }
                                    errorMessage={errors.questionTitle}
                                    touchedValue={touched.questionTitle}
                                />
                                {isGroup && (
                                    <Notes
                                        note={`This will apply to the group
                                    question including its children
                                    questions. i,e. ${
                                        values.questionTitle || 'PREFIX'
                                    }_${label}`}
                                    />
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn--sm btn--transparent m-r-10"
                                    disabled={isSubmitting || isRequesting}
                                    onClick={() => this.props.onClose()}
                                >
                                    Cancel
                                </button>
                                <button
                                    disabled={isSubmitting || isRequesting}
                                    className="btn btn--sm btn--green"
                                    type="submit"
                                >
                                    {isSubmitting || isRequesting
                                        ? 'Duplicating question'
                                        : 'Duplicate question'}
                                </button>
                            </ModalFooter>
                        </Form>
                    )}
                />
            </Modal>
        );
    }
}

export default NotifyHOC(DuplicateQuestionModal);
